import { type ExperienceItem } from "@/components/design-system/ExperienceCard/ExperienceCard";

export const cards: readonly ExperienceItem[] = [
  {
    image: "/cu-member-1.png",
    title: "Answers, not articles",
    description:
      "Members ask real questions — about budgeting, debt, savings goals, loan decisions. Bravo answers them conversationally, personally, and 24/7.",
  },
  {
    image: "/cu-member-2.png",
    title: "Full picture, one place",
    description:
      "Real-time account aggregation surfaces idle cash, savings gaps, and spending patterns — so Bravo can proactively guide members toward better outcomes and relevant products.",
  },
  {
    image: "/cu-member-3.png",
    title: "No judgment, no waiting",
    description:
      "Some questions are hard to ask out loud. Bravo gives every member a private, pressure-free space to work through real financial decisions — anytime, on their own terms.",
  },
  {
    image: "/cu-member-4.png",
    title: "Your brand, everywhere",
    description:
      "Your logo, your colors, your credit union's name. Members see only you — Bravo powers every conversation invisibly behind your brand identity.",
  },
];
